export const TIERS = 'Tiers';
export const SOCIETE = 'Societe';
export const PRODUIT = 'Produit';
export const EMPLACEMENT = 'Emplacement';
